// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.common.SortingRequest */
/* istanbul ignore next */
@GandalfModel
export class SortingRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Descending is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	descending!: boolean;

	@GandalfValidator({ notNull: { message: 'Field Name is required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	fieldName!: string;

}
